import type {ReactElement} from 'react';
import type {SettingsPanelProps} from '@Panels/settings-panel/settings-panel.types';
import {MODALS_IDS} from '@Components/modal-container';
import {Modal} from '@Components/modal';
import {LazyPanel} from '@Components/lazy-panel';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {useAppSelector} from '@/hooks';

const PANEL_ID = 'settings-modal-panel';

export type SettingsModalProps = SettingsPanelProps;

export default function SettingsModal(): ReactElement<any> {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.SETTINGS_MODAL];
  });
  const directoryName = 'settings-panel';
  const height = 'auto';
  const width = '400px';
  const mobileHeight = '855px';

  return (
    <Modal isBottomSheetOnMobile mobileHeight={mobileHeight} modalId={MODALS_IDS.SETTINGS_MODAL} panelId={PANEL_ID} modalHeight={height} modalWidth={width}>
      <LazyPanel
        panelDirectoryName={directoryName}
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openSettingsModal = (props: SettingsModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.SETTINGS_MODAL,
      panelProps: props,
    })
  );
};
